/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { GetFetch, PostFetch } from '../../../../../services/apiBase';
import CustomizedTables from '../../../../../components/Table';
import LoadingComponent from '../../../../../components/LoadingComponent';
import { enqueueSnackbar } from 'notistack';

export default function ChooseSignerModal(props) {
    const { signerToken, onClose } = props;
    const [signers, setSigners] = useState(null);
    const [loading, setLoading] = useState(false);

    const COLUMNSTABLE = [
        {
            headerName: 'Nome',
            type: 'default',
            value: {
                first: {
                    value: 'name'
                }
            }
        },
        {
            headerName: 'Email',
            type: 'default',
            value: {
                first: {
                    value: 'email'
                },
            }
        },
    ]

    const sendDocument = async (row) => {
        try {
            // Chamar requisição para atualizar signatário
            const requestData = {
                email: row.email,
                name: row.name,
            };
            const response = await PostFetch(`/financial/zapsign/signers/${signerToken}`, requestData);

            // Redirecionar para a URL de assinatura
            window.location.href = response.data?.sign_url
        } catch (error) {
            enqueueSnackbar('Ocorreu um erro ao tentar assinar o documento', { variant: 'error' })
        }
    }

    const tableAction = (row) => {
        return (
            <Button
                variant="contained"
                size="small"
                onClick={() => sendDocument(row)}
            >
                Enviar
            </Button>
        )
    }

    const tableComponent = () => {
        if (signers) {
            if (signers.length > 0) {
                return (<>
                    <CustomizedTables
                        data={signers}
                        columns={COLUMNSTABLE}
                        moreOptionsTitle="Ações"
                        moreOptions={tableAction}
                    />
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        height: '100%',
                        justifyContent: 'center',
                        paddingTop: 2
                    }}>
                    </Box>
                </>)
            }
        }

        return (
            <Box sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
                margin: 3
            }}>
                <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                    Usuários não foram encontrados
                </Typography>
            </Box>
        )
    }

    const getSigners = async () => {
        setLoading(true)
        try {
            const url = `/financial/zapsign/getSigners`;
            const result = await GetFetch(url);
            setSigners(result.data);
        } catch (error) {
            console.error(error.message);
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getSigners();
    }, [])

    return (
        <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            boxShadow: 24,
            borderRadius: 2,
            backgroundColor: grey[300]
        }}>
            <Box sx={{
                padding: '16px',
                borderRadius: '8px 8px 0 0',
                backgroundColor: '#fff'
            }}>
                <Typography variant="h6" component="h2">
                    Escolha usuário para encaminhar documento
                </Typography>
                {loading
                    ? <LoadingComponent />
                    : tableComponent()
                }
            </Box>

            <Button onClick={onClose}>Fechar</Button>
        </Box>
    )
}
